export default __webpack_public_path__ + "static/media/8822.0e39e785.svg";